import { Routes } from '@angular/router';
import { AuthGuard } from '../shared/guards/auth.guard';
import { StatisticsComponent } from './pages/statistics/statistics.component';

export const StatistcsRoutes: Routes = [{ path: '', pathMatch: 'full', component: StatisticsComponent, canActivate: [AuthGuard] }];
